import React, { useState } from "react";
import { string, object, func } from "prop-types";
import { formatTimeAgo, formatFullDate } from "helpers/date";
import styles from "./style.module.scss";

const Arrow = () => <span className={styles.arrow}>→</span>;

const TimeLabel = ({ dateStr }) => {
  const [hovered, setHovered] = useState(false);
  return (
    <span
      className={styles.timeLabel}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {formatTimeAgo(dateStr)}
      {hovered && (
        <span className={styles.timeTooltip}>{formatFullDate(dateStr)}</span>
      )}
    </span>
  );
};

TimeLabel.propTypes = { dateStr: string };

const ChangeRow = ({ label, from, to }) => (
  <div className={styles.changeRow}>
    <span className={styles.changeLabel}>{label}</span>
    <span className={styles.memberName}>{from ?? "N/A"}</span>
    <Arrow />
    <span className={styles.memberName}>{to ?? "N/A"}</span>
  </div>
);

ChangeRow.propTypes = { label: string, from: string, to: string };

const LogRow = ({ log, getUserName }) => {
  const { modifications, modified_by, modified_at } = log;
  const actorName = getUserName(modified_by);

  return (
    <div className={styles.logRow}>
      {/* Name + time */}
      <div className={styles.actorInfo}>
        <span className={styles.actorName}>{actorName}</span>
        <TimeLabel dateStr={modified_at} />
      </div>

      {/* Changes — mỗi loại 1 dòng, chỉ render cái có dữ liệu */}
      <div className={styles.changesList}>
        {modifications?.status && (
          <ChangeRow
            label="Status:"
            from={
              modifications.status.from === "new"
                ? "unassigned"
                : modifications.status.from
            }
            to={
              modifications.status.to === "new"
                ? "unassign"
                : modifications.status.to
            }
          />
        )}
        {modifications?.labeler && (
          <ChangeRow
            label="Labeler:"
            from={
              modifications.labeler.from
                ? getUserName(modifications.labeler.from)
                : null
            }
            to={
              modifications.labeler.to
                ? getUserName(modifications.labeler.to)
                : null
            }
          />
        )}
        {modifications?.reviewer && (
          <ChangeRow
            label="Reviewer:"
            from={
              modifications.reviewer.from
                ? getUserName(modifications.reviewer.from)
                : null
            }
            to={
              modifications.reviewer.to
                ? getUserName(modifications.reviewer.to)
                : null
            }
          />
        )}
      </div>
    </div>
  );
};

LogRow.propTypes = { log: object, getUserName: func };

export default LogRow;
